import React from 'react';
import Timesheet from './Timesheet';
import { GET_TIMESHEET_THRESHOLD } from '../../admin/queries';
import { Query } from 'react-apollo';

const TimesheetContainer = ({ timesheet, endDate, view }) => (
  <Query query={GET_TIMESHEET_THRESHOLD}>
    {({ error, data }) => {
      if (error) throw new Error(error);
      return <Timesheet timesheet={timesheet} endDate={endDate} threshold={data} view={view} />;
    }}
  </Query>
);

export default TimesheetContainer;
